import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import NotificationsSettings from './Table';
import { operations, selectors } from '../../../store/notifications';

const mapStateToProps = (state: any) => ({
  hasFetchedSettings: selectors.hasFetchedSettings(state),
  isFetchingSettings: selectors.isFetchingSettings(state),
  isSavingSettings: selectors.isSavingSettings(state),
  settings: selectors.notificationSettings(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
  toggleSetting:
    (settings: any) => (type: string, value: string, enabled: boolean) => {
      const settingsPatch = {
        [type]: {
          ...settings[type],
          [value]: enabled,
        },
      };
      dispatch(operations.saveNotificationSettings(settingsPatch));
    },
});

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => {
  const { toggleSetting } = dispatchProps;
  const { settings } = stateProps;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    toggleSetting: toggleSetting(settings),
  };
};

const ConnectedNotificationsSettings = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NotificationsSettings);

const NotificationsSettingsContainer = (props: any) => {
  const dispatch = useDispatch();
  const { hasFetchedSettings } = props;

  useEffect(() => {
    if (!hasFetchedSettings) {
      dispatch(operations.fetchNotificationSettings());
    }
  }, [hasFetchedSettings, dispatch]);

  return <ConnectedNotificationsSettings {...props} />;
};

export default connect(mapStateToProps)(NotificationsSettingsContainer);
